(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-shared/deposit-input.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-shared/deposit-input.js');

'use strict';

const {
  amountChangeAction
} = svs.accountservicesReact.deposit.store.deposit.actions;
const {
  instantPayAmountChange
} = svs.accountservicesReact.deposit.store.deposit.actions;
const {
  ControlGroup
} = svs.ui.reactForm;
const {
  AmountInput
} = svs.ui.reactFormInputs;
const {
  amountLimits
} = svs.accountservicesReact.deposit.constants;
const minAmountErrorText = 'Minsta insättningsbelopp är 25 kr.';
const maxAmountErrorText = 'Högsta insättningsbelopp är 25 000 kr.';
const errorMessageDefault = 'Fyll i ett belopp med endast siffror.';
const requiredErrorText = 'Fyll i ett belopp.';
const DepositInput = () => {
  const dispatch = ReactRedux.useDispatch();
  const setDepositAmount = money => dispatch(amountChangeAction(money));
  const depositAmount = ReactRedux.useSelector(state => state.deposit.amount);
  const handleOnChangeAmount = e => {
    const money = Number.parseInt(e.target.value, 10);
    if (money > 0) {
      setDepositAmount(money);
      dispatch(instantPayAmountChange(money));
    } else if (isNaN(money)) {
      setDepositAmount('');
    }
  };
  return React.createElement(ControlGroup, {
    className: "f-body line-height-150 margin-xs-bottom",
    isLessSpace: true,
    v2: true
  }, React.createElement(AmountInput, {
    errorMessageDefault: errorMessageDefault,
    errorMessageMax: maxAmountErrorText,
    errorMessageMin: minAmountErrorText,
    errorMessageRequired: requiredErrorText,
    id: "amount",
    inputHelpText: "Minsta ins\xE4ttning 25 kr.",
    inputMode: "numeric",
    isLessSpace: true,
    isRequired: true,
    label: "Belopp att s\xE4tta in",
    max: amountLimits.MAX,
    min: amountLimits.MIN,
    name: "amount",
    onChange: e => handleOnChangeAmount(e),
    step: "1",
    suffix: "kr",
    value: depositAmount
  }));
};
svs.accountservicesReact.deposit.depositShared.DepositInput = DepositInput;

 })(window);